module.exports = __webpack_public_path__ + "static/media/ic_pin_mapa.2f4d5dfe.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_pin_mapa.webp
// module id = 191
// module chunks = 1